/**
 * Web stub for `react-native-permissions`. Browser permission prompts are
 * driven by the relevant Web APIs themselves; here we just return GRANTED
 * so the existing slice flow continues.
 */

export const RESULTS = {
  GRANTED: 'granted',
  DENIED: 'denied',
  BLOCKED: 'blocked',
  UNAVAILABLE: 'unavailable',
  LIMITED: 'limited',
} as const;

export const PERMISSIONS = {
  ANDROID: { ACCESS_FINE_LOCATION: 'android.permission.ACCESS_FINE_LOCATION' },
  IOS: { LOCATION_WHEN_IN_USE: 'ios.permission.LOCATION_WHEN_IN_USE' },
} as const;

export const request = async (_permission: string): Promise<string> => RESULTS.GRANTED;
export const check = async (_permission: string): Promise<string> => RESULTS.GRANTED;
